module.exports = __webpack_public_path__ + "img/close-search.45896101.svg";